/**
 * Copy shared by the premium locks.
 *
 * Kept together so the two surfaces stay recognisably the same offer: a teacher who meets the
 * reading lock and then an admin who meets the dashboard lock should not be reading two different
 * explanations of one threshold.
 */

/**
 * The sentence that stops a school assuming it has to buy every seat itself, and that a seat only
 * counts once an admin has handed it to a child.
 *
 * Load-bearing, not reassurance: the gate counts CAPACITY, so an unassigned seat and a child
 * covered by a parent's own family subscription each move the bar exactly as far as a seat the
 * school bought and assigned. Schools that miss this read the threshold as a purchase minimum, or
 * as a bar that punishes them for not finishing their roster.
 */
export const PREMIUM_CAPACITY_NOTE =
  'Murid Premium dari paket sekolah maupun Premium mandiri orang tua sama-sama dihitung.'

/** What the school dashboard opens up, for the locked tab panel. */
export const SCHOOL_DASHBOARD_BENEFITS = [
  'Melihat tren aktivitas baca & belajar per tingkat kelas',
  'Menemukan murid & guru paling aktif, serta murid yang perlu perhatian',
  'Melihat rata-rata nilai per mata pelajaran dan fokus keterampilan',
  'Mengunduh data untuk rapat guru dan laporan sekolah/yayasan',
]

// DISABLED: the premium unlock for teachers is not shipping, so nothing renders these benefits.
// Commented out, not deleted, so the reader's school-gate arm can come back with the feature.
// /** What clearing the reading threshold gives the staff room, for the reader modal. */
// export function teacherReadingBenefits(threshold: number) {
//   return [
//     'Akses semua konten & fitur premium',
//     `Cukup ${threshold} siswa Premium aktif di sekolahmu`,
//     'Bisa dari paket sekolah premium atau Premium mandiri orang tua siswa',
//   ]
// }
